import { z } from 'zod'

export const activeExperimentSchema = z.object({
    id: z.string(),
    title: z.string(),
    version: z.string(),
})

export type ActiveExperiment = z.infer<typeof activeExperimentSchema>
